import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useNavigate } from 'react-router-dom';
import failuer from '../../../assets/animation/failuer.json';

function OrderFailuer() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/customer-home'); // update if needed
  };

  return (
    <div className="h-[calc(100vh-80px)] flex justify-center items-center px-4 overflow-y-auto">
      <div className="flex flex-col justify-center items-center bg-white rounded-xl shadow-lg p-8 w-full max-w-xl space-y-5">

        {/* Lottie Animation */}
        <Player
          autoplay
          loop={true}
          src={failuer}
          style={{ height: '300px', width: '300px' }}
        />

        <div className="text-4xl font-semibold text-center text-red-600">
          Payment Failed!
        </div>
        <div className="text-xl text-[#565656] text-center">
          Sorry, your transaction could not be completed.
        </div>

        {/* <div className="flex justify-center items-center w-[380px] h-[50px] font-[600] text-[#d32f2f] border border-[#d32f2f] bg-[#fdecea] rounded-[5px]">
          Transaction ID: 947R93UJFI
        </div> */}

        <div className="text-lg font-[500] text-center">
          Please try again or contact support if the issue persists.
        </div>

        {/* Go to Home Button */}
        <button
          onClick={handleGoHome}
          className="mt-4 px-6 py-2 bg-[#d32f2f] text-white font-semibold rounded-[5px] hover:bg-[#a72828] transition-colors"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
}

export default OrderFailuer;
